import { createContext, useContext, useState } from 'react';

const BookingContext = createContext(null);

export const BookingProvider = ({ children }) => {
  const [searchParams, setSearchParams] = useState({
    checkIn: null,
    checkOut: null,
    guests: 2,
    propertyId: null,
  });
  
  const [selectedRoom, setSelectedRoom] = useState(null);
  const [searchResults, setSearchResults] = useState(null);
  const [booking, setBooking] = useState(null);

  const updateSearch = (params) => {
    setSearchParams((prev) => ({ ...prev, ...params }));
  };

  const clearSearch = () => {
    setSearchParams({
      checkIn: null,
      checkOut: null,
      guests: 2,
      propertyId: null,
    });
    setSearchResults(null);
    setSelectedRoom(null);
  };

  const clearBooking = () => {
    setSelectedRoom(null);
    setBooking(null);
  };

  const value = {
    searchParams,
    updateSearch,
    clearSearch,
    selectedRoom,
    setSelectedRoom,
    searchResults,
    setSearchResults,
    booking,
    setBooking,
    clearBooking,
  };

  return <BookingContext.Provider value={value}>{children}</BookingContext.Provider>;
};

export const useBooking = () => {
  const context = useContext(BookingContext);
  if (!context) {
    throw new Error('useBooking must be used within a BookingProvider');
  }
  return context;
};
